(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-countdown-timer')) {
    class ProductCountdownTimer extends HTMLElement {
      connectedCallback() {
        window.clearInterval(this.interval);
        this.endTime = new Date(this.dataset.endDate).getTime();

        if (Number.isNaN(this.endTime)) {
          this.hidden = true;
          return;
        }

        if (!this.update()) return;
        this.interval = window.setInterval(() => {
          if (!this.update()) window.clearInterval(this.interval);
        }, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      update() {
        const remaining = Math.max(0, this.endTime - Date.now());
        const values = [
          Math.floor(remaining / 86400000),
          Math.floor(remaining / 3600000) % 24,
          Math.floor(remaining / 60000) % 60,
          Math.floor(remaining / 1000) % 60
        ];
        const output = this.querySelector('[data-product-countdown-value]');

        if (output) {
          output.textContent = values.map((value) => String(value).padStart(2, '0')).join(':');
          output.setAttribute('aria-label', `${values[0]} days, ${values[1]} hours, ${values[2]} minutes, ${values[3]} seconds`);
        }

        return remaining;
      }
    }

    customElements.define('product-countdown-timer', ProductCountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
